import { DialogContent } from "@mui/material";
import { useToast } from "@src/appV2/lib";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { FilePreview } from "@src/appV2/redesign/components/FilePreview/FilePreview";
import { type UploadedFile } from "@src/appV2/redesign/Documents/useFileUploaderContext";
import { useModalState } from "@src/appV2/redesign/system/ui-components";

import { FileSelectionBottomSheet } from "../../../components/FileSelectionBottomSheet";
import { CONTENT_TYPES, FOOTER_BUTTON_MIN_WIDTH } from "../constants";

interface FilePreviewStepProps {
  file: UploadedFile;
  onReplace: (newFile: UploadedFile) => void;
  onDelete: () => void;
}

export function FilePreviewStep(props: FilePreviewStepProps) {
  const { file, onReplace, onDelete } = props;
  const modalState = useModalState();
  const { showErrorToast } = useToast();

  return (
    <>
      <DialogContent
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.palette.background.tertiary,
        })}
      >
        <FilePreview file={file} />
      </DialogContent>

      <DialogFooter withShadow orientation="horizontal">
        <Button
          size="large"
          variant="text"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={() => {
            modalState.openModal();
          }}
        >
          Replace
        </Button>
        <Button
          size="large"
          variant="text"
          sx={(theme) => ({
            minWidth: FOOTER_BUTTON_MIN_WIDTH,
            color: theme.palette.error.main,
          })}
          onClick={onDelete}
        >
          Delete
        </Button>
      </DialogFooter>

      <FileSelectionBottomSheet
        modalState={modalState}
        contentTypes={CONTENT_TYPES}
        onFileAdded={(newFile) => {
          onReplace(newFile);
        }}
        onFilesAdded={(files) => {
          if (files.length > 0) {
            onReplace(files[0]);
          }
        }}
        onCameraPermissionDenied={() => {
          showErrorToast("Camera permission is required to take a photo.");
        }}
      />
    </>
  );
}
